<template>
    <v-form
        v-model="inputs_valid"
        action="/two-factor-challenge"
        method="post"
        ref="twofa_challenge_form"
        class="px-0 mx-0 tw-h-screen md:tw-h-auto"
        v-on:submit.prevent
    >

        <v-container>
            <div class="tw-flex tw-justify-center">
                <v-text-field v-show="false" type="hidden" id="_token" name="_token" v-model="token"/>

                <div class="tw-flex tw-flex-col tw-w-full md:tw-w-5/6 tw-justify-end tw-px-0 md:tw-px-14 tw-pt-12 md:tw-pt-6 tw-pb-2">
                    Please enter the code that was sent to you
                    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-3">
                        <v-text-field
                            v-model="code"
                            :rules="[rules.required]"
                            label="2FA Code"
                            id="twofacode"
                            name="code"
                            :error-messages="errors?.code"
                            required
                            autofocus
                        ></v-text-field>
                    </div>
                </div>

                <div class="tw-flex tw-flex-col-reverse md:tw-flex-row tw-justify-start md:tw-justify-end tw-items-start md:tw-items-center tw-gap-4">

                    <v-btn
                        type="submit"
                        @click="submitForm"
                        :disabled="!inputs_valid"
                        class="main-btn tw-w-full md:tw-w-48"
                    >
                        Continue
                    </v-btn>
                </div>

            </div>
        </v-container>


    </v-form>
</template>

<script>


export default {
    name: "AuthBar2faCode",

    data: () => ({
        inputs_valid: false,
        code: '',
        rules: {
            required: value => !!value || 'Required',
        },
        token: null,
        expanded_panel_index: null,
        errors: null,
    }),

    computed: {
        payload: function () {
            return {
                _token: this.getToken(),
                code: this.code,
            }
        },
    },

    methods: {
        reset () {
            this.expanded_panel_index = null
            this.$nextTick(()=>{
                this.$refs.twofa_challenge_form.reset()
            })
        },
        resetValidation () {
            this.$refs.twofa_challenge_form.resetValidation()
            this.errors = null
        },
        getToken () {
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        async submitForm () {
            axios.post('/two-factor-challenge', this.payload)
                .then((response) => {
                    window.location = '/'
                    // if( response.data?.success ) {
                    //     if( response.data.redirect_url ) {
                    //
                    //         // Menu system will need to be updated according to the newly logged-in user's role.
                    //         let user_role = response.data.user_role
                    //         this.$root.user_role = user_role
                    //         let new_menu_name = this.$root.navtop?.getMenuNameByRole(user_role)
                    //         // this.$root.navtop?.updateMenuName(new_menu_name)
                    //
                    //         window.location = response.data.redirect_url
                    //     }
                    // }
                })
                .catch((error) => {
                    if( error?.response ) {
                        this.$root.snackbar.error(error.response.data.message)
                        this.errors = error.response?.data?.errors
                    } else {
                        console.log(error)
                        this.$root.snackbar.error(error)
                    }
                })
        },
    },

    created() {
        this.submitForm = _.debounce(this.submitForm, 666) // Replace this function with a debounced version of itself
    },

    mounted() {
        this.token = this.getToken()
    },
    watch: {
        code(newValue, oldValue) {
            this.resetValidation()
        },
    }
}
</script>
